/* ==========================================================================
   USPA BA – redizajn kartice proizvoda i stranice proizvoda
   1) Kartica: listanje slika strelicama
   2) Kartica: izbor veličine + "Dodaj u korpu" bez odlaska na stranicu proizvoda
      (desktop na hover, mobilni preko dugmeta sa korpom na slici)
   3) Kartica: prelazak mišem preko kružića boje prikazuje sliku te boje
   4) Stranica proizvoda: naziv boje pri prelasku preko thumbnaila druge boje
   5) Kolekcija, desktop: filteri kao padajući meniji u jednom redu
   6) Grid: naziv i cijena u istoj ravni kod svih kartica jednog reda

   Sve radi preko delegiranih događaja na document, pa važi i za kartice
   koje se naknadno učitaju (filteri, paginacija, preporuke).
   ========================================================================== */
(function () {
  'use strict';

  if (window.__uspaRedesignLoaded) return;
  window.__uspaRedesignLoaded = true;

  function closest(el, selector) {
    return el && el.closest ? el.closest(selector) : null;
  }

  /* ---------- 1) Kartica: listanje slika ---------- */

  function getAltImage(media) {
    var img = media.querySelector('.uspa-card__alt-img');
    if (!img) {
      img = document.createElement('img');
      img.className = 'uspa-card__alt-img';
      img.alt = '';
      img.decoding = 'async';
      var wrap = media.querySelector('.image-label-wrap') || media;
      var first = wrap.firstElementChild;
      wrap.insertBefore(img, first ? first.nextSibling : null);
    }
    return img;
  }

  function getImageList(media) {
    return (media.getAttribute('data-uspa-images') || '').split('|').filter(Boolean);
  }

  function showImage(media, index) {
    var list = getImageList(media);
    var img = getAltImage(media);
    if (list.length < 2) {
      img.classList.remove('is-visible');
      return;
    }
    var i = ((index % list.length) + list.length) % list.length;
    media.setAttribute('data-uspa-index', String(i));
    if (i === 0) {
      img.classList.remove('is-visible');
      return;
    }
    img.src = list[i];
    img.classList.add('is-visible');
  }

  function currentIndex(media) {
    return parseInt(media.getAttribute('data-uspa-index') || '0', 10) || 0;
  }

  /* ---------- 2) Kartica: dodavanje u korpu ---------- */

  function flash(btn, text, restoreText, className) {
    if (!text) return;
    btn.textContent = text;
    if (className) btn.classList.add(className);
    window.clearTimeout(btn.__uspaTimer);
    btn.__uspaTimer = window.setTimeout(function () {
      btn.textContent = restoreText;
      if (className) btn.classList.remove(className);
    }, 2000);
  }

  function addToCart(card, btn, variantId) {
    if (btn.classList.contains('is-loading')) return;

    var theme = window.theme || {};
    var routes = theme.routes || {};
    var label = btn.getAttribute('data-label') || btn.textContent;
    var addUrl = routes.cart_add_url || '/cart/add.js';
    var cartUrl = routes.cart_url || '/cart';
    var useDrawer = !!(theme.settings && theme.settings.cart_type === 'drawer' &&
      typeof theme.addedToCartHandler === 'function' && theme.jQuery);

    var body = 'id=' + encodeURIComponent(variantId) + '&quantity=1';
    if (useDrawer) body += '&sections=cart-drawer';

    btn.classList.add('is-loading');

    fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: body
    })
      .then(function (response) {
        return response.json().then(function (json) {
          return { ok: response.ok, json: json };
        });
      })
      .then(function (result) {
        btn.classList.remove('is-loading');

        if (!result.ok) {
          flash(btn, result.json.description || result.json.message || 'Nije dostupno', label, 'is-error');
          return;
        }

        if (useDrawer && result.json.sections && result.json.sections['cart-drawer']) {
          try {
            if (typeof theme.removeAddedCartDrawer === 'function') theme.removeAddedCartDrawer();
            theme.addedToCartHandler.call(theme.jQuery(card), result.json);
            var hideOnScroll = function () {
              window.removeEventListener('scroll', hideOnScroll);
              if (typeof theme.removeAddedCartDrawer === 'function') theme.removeAddedCartDrawer();
            };
            window.setTimeout(function () {
              window.addEventListener('scroll', hideOnScroll, { passive: true });
            }, 400);
          } catch (e) {
            window.location.href = cartUrl;
            return;
          }
          flash(btn, btn.getAttribute('data-label-added') || label, label, 'is-added');
        } else {
          window.location.href = cartUrl;
        }
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        var link = card.querySelector('a.product-link');
        if (link) window.location.href = link.href;
      });
  }

  /* ---------- 2b) Kartica (mobilni): dugme sa korpom otvara veličine ---------- */

  function closeQuickPanels(exceptCard) {
    var open = document.querySelectorAll('.uspa-card.is-quick-open');
    for (var i = 0; i < open.length; i++) {
      if (open[i] === exceptCard) continue;
      open[i].classList.remove('is-quick-open');
      var btn = open[i].querySelector('[data-uspa-quick-toggle]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }
  }

  /* ---------- 5) Kolekcija, desktop: filteri kao padajući meniji ---------- */

  var desktopFilters = window.matchMedia('(min-width: 1000px)');
  var openFilterLabel = null;

  function filterLabel(group) {
    var text = group.querySelector('.filter-group__heading__text');
    return text ? text.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function setOpenFilter(label) {
    openFilterLabel = label || null;
    var groups = document.querySelectorAll('[data-uspa-coll] .filters .filter-group');
    for (var i = 0; i < groups.length; i++) {
      var heading = groups[i].querySelector('a.filter-group__heading');
      if (!heading) continue;
      var isOpen = !!openFilterLabel && filterLabel(groups[i]) === openFilterLabel;
      if (groups[i].classList.contains('is-open') !== isOpen) groups[i].classList.toggle('is-open', isOpen);
      heading.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
  }

  /* Hvatamo klik prije teme (capture), da njen "harmonika" efekat ne radi na desktopu. */
  document.addEventListener('click', function (evt) {
    if (!desktopFilters.matches) return;
    var heading = closest(evt.target, '[data-uspa-coll] .filters a.filter-group__heading');
    if (heading) {
      evt.preventDefault();
      evt.stopPropagation();
      var label = filterLabel(closest(heading, '.filter-group'));
      setOpenFilter(label === openFilterLabel ? null : label);
      return;
    }
    if (openFilterLabel && !closest(evt.target, '[data-uspa-coll] .filters .filter-group.is-open')) {
      setOpenFilter(null);
    }
  }, true);

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape' && openFilterLabel) setOpenFilter(null);
  });

  /* ---------- 6) Grid: naziv i cijena u istoj ravni ---------- */

  var ALIGN_SELECTORS = ['.product-block__title', '.product-price'];

  function alignCards() {
    var lists = document.querySelectorAll('.product-list:not(.carousel)');
    var jobs = [];
    var i, j, k;

    for (i = 0; i < lists.length; i++) {
      var cards = [];
      for (j = 0; j < lists[i].children.length; j++) {
        if (lists[i].children[j].classList.contains('uspa-card')) cards.push(lists[i].children[j]);
      }
      if (cards.length < 2) continue;
      for (k = 0; k < ALIGN_SELECTORS.length; k++) {
        var els = [];
        for (j = 0; j < cards.length; j++) {
          var el = cards[j].querySelector(ALIGN_SELECTORS[k]);
          if (el) {
            el.style.minHeight = '';
            els.push({ el: el, card: cards[j] });
          }
        }
        jobs.push(els);
      }
    }

    /* prvo sva čitanja, pa sva pisanja */
    var writes = [];
    for (i = 0; i < jobs.length; i++) {
      var rows = {};
      for (j = 0; j < jobs[i].length; j++) {
        var item = jobs[i][j];
        var top = item.card.offsetTop;
        var height = item.el.offsetHeight;
        if (!rows[top]) rows[top] = { max: 0, items: [] };
        rows[top].items.push({ el: item.el, height: height });
        if (height > rows[top].max) rows[top].max = height;
      }
      for (var key in rows) {
        if (!Object.prototype.hasOwnProperty.call(rows, key)) continue;
        for (j = 0; j < rows[key].items.length; j++) {
          if (rows[key].items[j].height < rows[key].max) {
            writes.push({ el: rows[key].items[j].el, height: rows[key].max });
          }
        }
      }
    }
    for (i = 0; i < writes.length; i++) writes[i].el.style.minHeight = writes[i].height + 'px';
  }

  var alignTimer = null;
  function scheduleAlign() {
    window.clearTimeout(alignTimer);
    alignTimer = window.setTimeout(alignCards, 120);
  }

  function refreshAfterContentChange() {
    if (openFilterLabel) setOpenFilter(openFilterLabel);
    scheduleAlign();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alignCards);
  } else {
    alignCards();
  }
  window.addEventListener('load', alignCards);
  window.addEventListener('resize', scheduleAlign);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(alignCards);

  /* Filtriranje, sortiranje i paginacija zamjenjuju sadržaj bez novog učitavanja stranice. */
  if (window.MutationObserver) {
    var startObserver = function () {
      var roots = document.querySelectorAll('[data-section-type="collection-template"], .product-list:not(.carousel)');
      if (!roots.length) return;
      var observer = new MutationObserver(refreshAfterContentChange);
      for (var i = 0; i < roots.length; i++) {
        observer.observe(roots[i], { childList: true, subtree: true });
      }
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startObserver);
    } else {
      startObserver();
    }
  }

  document.addEventListener('click', function (evt) {
    var target = evt.target;

    var quickToggle = closest(target, '[data-uspa-quick-toggle]');
    if (quickToggle) {
      evt.preventDefault();
      var toggleCard = closest(quickToggle, '.uspa-card');
      if (toggleCard) {
        closeQuickPanels(toggleCard);
        toggleCard.classList.add('is-quick-open');
        quickToggle.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    if (!closest(target, '[data-uspa-quick]')) closeQuickPanels(null);

    /* mobilni: prebacivanje 1/2 kolone mijenja širinu kartica */
    if (closest(target, '.layout-switch')) scheduleAlign();

    var arrow = closest(target, '[data-uspa-img-prev], [data-uspa-img-next]');
    if (arrow) {
      evt.preventDefault();
      var media = closest(arrow, '[data-uspa-images]');
      if (media) {
        var step = arrow.hasAttribute('data-uspa-img-next') ? 1 : -1;
        showImage(media, currentIndex(media) + step);
      }
      return;
    }

    var size = closest(target, '[data-uspa-size]');
    if (size) {
      evt.preventDefault();
      if (size.disabled) return;
      var quickForSize = closest(size, '[data-uspa-quick]');
      if (!quickForSize) return;
      var sizes = quickForSize.querySelectorAll('[data-uspa-size]');
      for (var i = 0; i < sizes.length; i++) {
        sizes[i].classList.toggle('is-selected', sizes[i] === size);
        sizes[i].setAttribute('aria-pressed', sizes[i] === size ? 'true' : 'false');
      }
      quickForSize.setAttribute('data-variant-id', size.getAttribute('data-variant-id'));
      return;
    }

    var add = closest(target, 'button[data-uspa-add]');
    if (add) {
      evt.preventDefault();
      var quick = closest(add, '[data-uspa-quick]');
      var card = closest(add, '.product-block');
      var variantId = add.getAttribute('data-variant-id') || (quick && quick.getAttribute('data-variant-id'));
      var addLabel = add.getAttribute('data-label') || add.textContent;
      if (!variantId) {
        flash(add, add.getAttribute('data-label-pick'), addLabel, 'is-error');
        return;
      }
      if (card) addToCart(card, add, variantId);
    }
  });

  /* ---------- 3) Kartica: pregled druge boje ---------- */

  function cardMedia(el) {
    var card = closest(el, '.product-block');
    return card ? card.querySelector('.uspa-card__media') : null;
  }

  document.addEventListener('mouseover', function (evt) {
    var swatch = closest(evt.target, '[data-uspa-swatch-img]');
    if (swatch) {
      var media = cardMedia(swatch);
      if (media) {
        var img = getAltImage(media);
        img.src = swatch.getAttribute('data-uspa-swatch-img');
        img.classList.add('is-visible');
      }
      return;
    }

    /* ---------- 4) Stranica proizvoda: naziv boje ---------- */
    var colorLink = closest(evt.target, '.uspa-colors__link');
    if (colorLink) {
      var box = closest(colorLink, '[data-uspa-colors]');
      var name = box && box.querySelector('[data-uspa-color-name]');
      if (name) name.textContent = colorLink.getAttribute('data-uspa-color') || '';
    }
  });

  document.addEventListener('mouseout', function (evt) {
    var swatch = closest(evt.target, '[data-uspa-swatch-img]');
    if (swatch) {
      var media = cardMedia(swatch);
      if (media) showImage(media, currentIndex(media));
      return;
    }

    var colorLink = closest(evt.target, '.uspa-colors__link');
    if (colorLink) {
      var box = closest(colorLink, '[data-uspa-colors]');
      var name = box && box.querySelector('[data-uspa-color-name]');
      if (name) name.textContent = name.getAttribute('data-default') || '';
    }
  });
})();
